<template>
  <div class="divBox">
    <el-card class="box-card">
      <el-form ref="form" label-width="80px">
       <div style="display: flex;align-items: center;flex-wrap: wrap">
         <el-form-item label="时间筛选">
           <el-date-picker
             v-model="tableFrom.date"
             value-format="yyyy-MM-dd"
             type="date"
             @change="getSearchListFn"
             placeholder="选择日期">
           </el-date-picker>
         </el-form-item>

         <el-form-item label="排序：" style="margin-left: 10px">
           <el-radio-group
             v-model="tableFrom.sort"
             type="button"
             @change="getList(1)"
           >
             <el-radio-button label="in">
               根据买入排序
             </el-radio-button>
             <el-radio-button label="form"
             >根据开单数排序
             </el-radio-button>
           </el-radio-group>
         </el-form-item>
         <el-form-item label="商品分类：" style="margin-left: 10px">
           <el-radio-group
             v-model="tableFrom.cate_id"
             type="button"
             @change="getList(1)"
           >
             <el-radio-button :label="item.recovery_category_id" v-for="(item,index) in selectList">
               {{item.cate_name}}
             </el-radio-button>
           </el-radio-group>
         </el-form-item>
<!--         <el-form-item label="商品分类：" class="width100" style="margin-left: 10px">-->
<!--           <el-select v-model="tableFrom.cate_id" @change="getList(1)" placeholder="请选择" style="width: 200px" >-->
<!--             <el-option-->
<!--               v-for="(i,indx) in selectList"-->
<!--               :key="i.recovery_category_id"-->
<!--               :label="i.cate_name"-->
<!--               :value="i.recovery_category_id"-->
<!--             >-->
<!--             </el-option>-->
<!--           </el-select>-->
<!--         </el-form-item>-->
         <el-form-item label="关键字：" class="width100" style="display: inline-block;">
           <el-input
             v-model="tableFrom.keywords"
             @keyup.enter.native="getList(1)"
             placeholder="请输入分类名称/sku"
             class="selWidth"
             size="small"
           >
             <el-button slot="append" icon="el-icon-search" size="small" class="el-button-solt" @click="getList(1)" />
           </el-input>
         </el-form-item>
         <el-form-item label="" class="width100" style="display: inline-block;">
           <el-button type="primary" @click="addGoodsFn" >添加商品库存</el-button>
         </el-form-item>
         <el-form-item label="" class="width100" style="display: inline-block;">
           <el-button type="primary" @click="visibleAddFn" >新增商品库存</el-button>
         </el-form-item>
         <el-form-item label="" class="width100" style="display: inline-block;">
           <el-button type="primary" @click="stockCardDateFn" >导出今日库存</el-button>
         </el-form-item>
       </div>

      </el-form>
      <cards-data :card-lists="cardLists" />
      <el-table
        v-loading="listLoading"
        :data="tableData.data"
        style="width: 100%"
        size="small"
        height="800"
      >
        <el-table-column
          label="ID"
          prop="recovery_stock_id"
          min-width="50" />
        <el-table-column
          label="商品"
          prop="sku"
          min-width="250" >
          <template slot-scope="scope">
            {{scope.row.category_name}} {{scope.row.sku}}
          </template>
        </el-table-column>
        <el-table-column
          label="入库总数量"
          prop="recovery_num"
          min-width="100" />
        <el-table-column
          label="今日入库"
          prop="inbound_num"
          min-width="100" />
        <el-table-column
          label="今日买入总金额"
          prop="plat_outbound_amount"
          min-width="120" >
          <template slot-scope="scope">
            {{scope.row.plat_outbound_amount?scope.row.plat_outbound_amount:'--'}}
          </template>
        </el-table-column>
        <el-table-column
          label="今日买入数量"
          prop="plat_outbound_num"
          min-width="100">
          <template slot-scope="scope">
            {{scope.row.plat_outbound_num?scope.row.plat_outbound_num:'--'}}
          </template>
        </el-table-column>
        <el-table-column
          label="今日买入均价"
          prop="plat_outbound_price"
          min-width="100">
          <template slot-scope="scope">
            {{scope.row.plat_outbound_price?scope.row.plat_outbound_price:'0.00'}}
          </template>
        </el-table-column>
        <el-table-column
          label="已买在库数量"
          prop="inbound_num"
          min-width="100" />
        <el-table-column
          label="今日开单数"
          prop="form_num"
          min-width="100" />
        <el-table-column
          label="开单后总在库成本"
          prop="inbound_num"
          min-width="100" >
          <template slot-scope="scope">
            <p>{{priceFn(scope.row)}}</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="220" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="isDateShowFn(scope.row)"  @click="setRecoveryStock(scope.row)">设置库存</el-button>
            <el-button type="text" size="small"  @click="stockDetailsLstFn(scope.row)">手动设置库存明细</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          :page-sizes="[20, 40, 60, 80]"
          :page-size="tableFrom.limit"
          :current-page="tableFrom.page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.total"
          @size-change="handleSizeChange"
          @current-change="pageChange"
        />
      </div>
    </el-card>



    <el-dialog title="新增商品" :visible.sync="visibleAddGood" width="500px" @close="closeDialogFn">
      <div style="margin: 0px 0px 10px">
        <div style="margin: 10px 0">
          <el-input
            placeholder="输入关键字进行过滤"
            v-model="filterText"

          >
          </el-input>
        </div>
      </div>
      <div style="max-height: 500px;overflow: auto;">
        <el-tree ref="elTree" node-key="recovery_category_id" :filter-node-method="filterNodeFn" :data="treeData"
                 show-checkbox :props="defaultProps" @check="deptNodeClick"></el-tree>
      </div>
      <div style="display: flex;align-items: center;margin-top: 20px">
        <el-input
          placeholder="输入新增数量"
          v-model="stock" >
        </el-input>
      </div>
      <div style="width: 100%;text-align: center;margin-top: 20px">
        <el-button type="primary" @click="choiceGoodsFn">确定</el-button>
      </div>
    </el-dialog>


    <el-dialog
      title="添加商品"
      :visible.sync="addGoodsShow"
      width="80%"
      top="50px"
      :before-close="addGoodsClose">

      <div style="height: 700px;overflow-y: scroll">
        <el-form ref="form" label-width="80px"  @submit.native.prevent>
          <div style="display: flex;align-items: center">
            <el-form-item label="搜索商品">
              <el-input v-model="keywords" style="width: 200px"    @keyup.enter.native="getSearchFn"></el-input>
              <el-button type="primary" @click="getSearchFn">搜索</el-button>
            </el-form-item>
          </div>
        </el-form>
        <div style="display:flex;align-items: center;flex-wrap: wrap">
          <el-radio-group v-model="gooditem">
            <div style="display: flex;align-items: center;border: 1px solid #dcdfe6;padding:12px 20px;margin: 8px" v-for="(item,index) in itemList">
              <el-radio :label="item">{{item.category_name}} {{item.sku}}</el-radio>
            </div>
          </el-radio-group>

        </div>

        <div style="display:flex;flex-direction: column;flex-wrap: wrap;margin-top: 20px">
          <div style="margin: 8px">
            <div style="display: flex;align-items: center" v-if="gooditem.recovery_category_id">
              <span>{{gooditem.category_name}} {{gooditem.sku}}</span>
<!--              <span style="margin-left: 20px">在库数量：{{item.recovery_num}}</span>-->
              <span style="margin-left: 20px">添加数量：</span>
              <el-input v-model="gooditem.stock" style="width: 200px" placeholder="请输入内容"></el-input>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addGoodsShow = false">取 消</el-button>
        <el-button type="primary" @click="stockOutConfirm">确 定</el-button>
      </span>
    </el-dialog>


    <el-dialog
      :title="addType=='edit'?'编辑':'添加客户'"
      :visible.sync="addClientShow"
      width="30%"
      :before-close="handleClose">

      <div class="">
        <el-form :inline="true" class="demo-form-inline">
          <div style="display:flex;flex-direction: column">
            <el-form-item label="客户名字">
              <el-input v-model="formData.custom_name" placeholder="名字"></el-input>
            </el-form-item>
            <el-form-item label="客户电话">
              <el-input v-model="formData.custom_contact" placeholder="联系电话"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addClientShow = false">取 消</el-button>
        <el-button type="primary" @click="addClientFn">确 定</el-button>
      </span>
    </el-dialog>




    <el-dialog
      title="手动设置库存明细"
      :visible.sync="stockDetailShow"
      width="45%"
      top="50px"
    >
      <el-table
        v-loading="listLoading"
        :data="stockDetail"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          label="ID"
          prop="stock_details_id"
          min-width="50" />
        <el-table-column
          label="数量"
          prop="stock_num"
          min-width="50" />
        <el-table-column
          label="操作类型"
          prop="type"
          min-width="50" >
          <template slot-scope="scope">
            <span>
              {{scope.row.type == 1 ? '增加':scope.row.type == 0 ?'减少':'一键设置'}}
            </span>

          </template>
        </el-table-column>
        <el-table-column
          label="备注"
          prop="remark"
          min-width="100" />
<!--        <el-table-column-->
<!--          label="批号"-->
<!--          prop=""-->
<!--          min-width="200">-->
<!--          <template slot-scope="scope">-->
<!--            <p v-for="(item,index) in batchListFn(scope.row)" style="margin: 0">-->
<!--              {{item.batch_number}} <span style="font-size: 16px;color: red;margin-left: 10px">x{{item.batch_num}}</span>-->
<!--            </p>-->
<!--          </template>-->

<!--        </el-table-column>-->
        <el-table-column
          label="创建时间"
          prop="create_time"
          min-width="100" />

      </el-table>
      <div class="block">
        <el-pagination
          :page-sizes="[15, 30]"
          :page-size="detailFrom.limit"
          :current-page="detailFrom.page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="detailFrom.total"
          @size-change="detailSizeChange"
          @current-change="detailChange"
        />
      </div>
    </el-dialog>

    <el-dialog
      :title="stockItem.category_name+stockItem.sku"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose">
      <el-form :model="ruleForm" status-icon ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="修改库存" prop="pass">
          <el-radio v-model="ruleForm.type" :label="1">增加</el-radio>
          <el-radio v-model="ruleForm.type" :label="0">减少</el-radio>
          <el-radio v-model="ruleForm.type" :label="2">一键设置</el-radio>
        </el-form-item>
       <div v-if="ruleForm.type!=2">
         <el-form-item label="库存" prop="checkPass">
           <el-input-number v-model="ruleForm.stock"  :min="1" :max="ruleForm.type == 0 ?stockItem.recovery_num:1000000" label="描述文字"></el-input-number>
         </el-form-item>
         <el-form-item label="备注" prop="checkPass">
           <el-input v-model="ruleForm.remark" placeholder="请输入内容" style="width: 300px"></el-input>
         </el-form-item>
<!--         <el-form-item label="" prop="checkPass" v-if="ruleForm.type == 1">-->
<!--           <el-button type="primary" @click="addBatchFn">增加批号</el-button>-->
<!--         </el-form-item>-->

         <el-form-item label="录入批号" prop="checkPass" v-for="(item,index) in ruleForm.batch_list"  v-if="ruleForm.type == 1">
           <el-input v-model="item.batch_number" placeholder="请输入内容" style="width: 300px;"></el-input>
           <el-input-number v-model="item.batch_num" @change="batchChange($event,index)" :max="maxFn(item,index)" label="描述文字" style="margin-left: 20px"></el-input-number>
         </el-form-item>
         <el-form-item label="批号" prop="checkPass" v-for="(item,index) in stockItem.stock_batch"  v-if="ruleForm.type == 0">
           <el-input v-model="item.batch_number" :disabled="true" placeholder="请输入内容" style="width: 300px;"></el-input>
           <el-input-number v-model="item.batchNum" @change="batchChange($event,index)" :max="stockMaxFn(item,index)" label="描述文字" style="margin-left: 20px"></el-input-number>
         </el-form-item>
       </div>
        <el-form-item label="设置库存" prop="checkPass" v-if="ruleForm.type == 2">
          <el-input v-model="ruleForm.stock" placeholder="请输入内容" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="checkPass" v-if="ruleForm.type == 2">
          <el-input v-model="ruleForm.remark" placeholder="请输入内容" style="width: 300px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="batchConfirm" v-loading="btnLoading">确 定</el-button>
  </span>
    </el-dialog>


    <el-dialog
      title="异常处理"
      :visible.sync="abnormalVisible"
      width="50%">
      <el-form :model="ruleForm" status-icon ref="ruleForm" label-width="100px" class="demo-ruleForm">
       <div style="display: flex;align-items: center">
         <el-form-item label="异常数量" prop="checkPass">
           <el-input-number size="mini" v-model="abnormalForm.stock"  :min="1" :max="ruleForm.type == 0 ?stockItem.recovery_num:1000000" label="描述文字"></el-input-number>
         </el-form-item>
         <el-form-item label="备注" prop="checkPass" v-for="(item1,index1) in abnormalForm.worn_list">
           <el-input size="mini" v-model="abnormalForm.worn_reason" placeholder="请输入内容" style="width: 200px"></el-input>
         </el-form-item>
       </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="abnormalVisible = false">取 消</el-button>
        <el-button type="primary" @click="abnormalConfirm" v-loading="btnLoading">确 定</el-button>
      </span>
    </el-dialog>


    <el-dialog
      title="删除客户"
      :visible.sync="deleteShow"
      width="30%"
      :before-close="handleClose">
      <div class="">
        确定删除客户【{{deleteData.custom_name}}】
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteShow = false">取 消</el-button>
        <el-button type="primary" @click="deleteConfirmFn">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  // +----------------------------------------------------------------------
  // | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
  // +----------------------------------------------------------------------
  // | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
  // +----------------------------------------------------------------------
  // | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
  // +----------------------------------------------------------------------
  // | Author: CRMEB Team <admin@crmeb.com>
  // +----------------------------------------------------------------------
  import { roterPre } from '@/settings'
  import {fromList} from "@/libs/constants";
  import createWorkBook from '@/utils/newToExcel.js';
  import {
    stockCardDate,
    stockSetDateUpdate,
    categoryList,
    customCreate,
    customDelete,
    stockDateList,
    tockCardDate,
    stockSetWorn,//修改异常
    addStock,
    stockDetailsLst,
    dateQuicklyUpdate,
    recoveryStockListApi,
    stockAdd, recoveryCategorySkuListApi
  } from "@/api/recovery";
  import cardsData from "@/components/cards";
  export default {
    name: 'appraisalEntityOrder',
    components: {cardsData},
    computed:{
      batchListFn(){
        return function (row) {
          if(row.batch_list){
            return JSON.parse(row.batch_list)
          }else{
            return []
          }
        }
      },
      /**
       * 判断该数据今日才能进行设置库存
       * */
      isDateShowFn(){
        return function (row) {
          let date = new Date()
          let y = date.getFullYear()
          let m = date.getMonth()+1
          let d = date.getDate()
          let data = y+'-'+(m<10?'0'+m:m)+'-'+(d<10?'0'+d:d)
          if(data == row.stock_date){
            return true
          }else{
            return false
          }
        }
      },
      /**
       * 返回开单后在库成本
       */
      priceFn(){
        return function (row) {
          let plat_outbound_amount = Number(row.totalStock.plat_outbound_amount) // 买入总价格
          let form_num = Number(row.totalStock.form_num) // 总开单数量
          let plat_outbound_price = Number(row.totalStock.plat_outbound_price) // 总买入均价
          if(row.recovery_stock_id == 536){
              console.log(plat_outbound_amount,form_num,plat_outbound_price)
          }
          return  (plat_outbound_amount - (form_num * plat_outbound_price)).toFixed(0)
        }
      },
      maxFn(){
        return function (item,index) {
          let num = 0
          this.ruleForm.batch_list.map((item1,index1)=>{
            num+= item1.batch_num
          })
          return  this.ruleForm.stock - num + item.batch_num
        }
      }

    },
    watch: {
      filterText(val) {//过滤树形图
        this.$refs.elTree.filter(val);
      }
    },
    data() {
      return {
        defaultProps: {
          children: 'children',
          label: 'cate_name'
        },
        addGoodsShow:false,
        btnLoading:false,
        stockItem:{},
        deleteData:{},
        keywords:'',
        visibleAddGood:false,
        customName:'',
        filterText:'',
        addForm:{
          stock:1
        },
        abnormalForm:{
          remark:'',
          type:1,
          stock:1,
          worn_list:[{
            txt:''
          }]
        },
        remarkList:[],// 异常备注列表
        gooditem:{},
        checkList:[],
        abnormalVisible:false,
        deleteShow:false,
        itemList:[],
        props: { checkStrictly: true, emitPath: false},
        moren: require("@/assets/images/f.png"),
        colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
        listLoading: true,
        selectList:[],
        tableData: {
          data: [],
          total: 0
        },
        detailFrom:{
          page:1,
          limit:15,
          total:0,
        },
        stockDetail:{},
        stockDetailShow:false,
        roterPre: roterPre,
        tableFrom: {
          page: 1,
          limit: 15,
          stock:1,
          date:'',
          sort:'',
          cate_id:'',
        },
        stock:'',
        currentCheckData:{},
        checkLst:[],
        custom_id:0,
        addType:'add',
        recovery_stock_id:0,
        goodsData:{},
        orderChartType: {},
        fromList: fromList,
        deptsValue:[],
        deptName:'',
        cardLists: [],
        timeVal: [],
        dialogVisible:false,
        loading: false,
        formData: {},
        addClientShow:false,
        stockId:0,
        ruleForm:{
          outbound_price:'',
          type:1,
          stock:1,
          batch_list:[],
        },
        appraisal_order_id:'',
        recoveryCateList:[],
      }
    },
    mounted() {
      this.getTimeFn()
      this.getList(1)
      this.getSelectFn()
      this.getGoodsFn()
    },
    methods: {
      handleCheckChange(data,check){

        if(data.level == 3){
          this.$nextTick(()=>{
            this.$refs.elTree.setCheckedKeys([])
          })
          if(!check){
            this.$nextTick(() => {
              this.$refs.elTree.setCheckedKeys([data.recovery_category_id])
            })
          }
        }
      },
      visibleAddFn(){
        this.stock = ''
        this.goodsData = {}
        this.visibleAddGood = true
        this.$refs.elTree.setCheckedNodes([])
      },
      filterNodeFn(value, data) {//过滤节点
        if (!value) return true;
        return data.cate_name.indexOf(value) !== -1;
      },
      deptNodeClick(data) {
        console.log(data,'------------')
        this.$refs.elTree.setCheckedNodes([data])
        this.goodsData = data
      },
      closeDialogFn(){
        this.visibleAddGood = false
      },
      choiceGoodsFn(){
        if(!this.goodsData.recovery_attr_id){
          this.$message.error('请选择商品数量')
          return
        }
       if(!this.stock){
         this.$message.error('请输入商品数量')
         return
       }
        let params = {
          stock:this.stock,
          recovery_attr_id:this.goodsData.recovery_attr_id,
          recovery_category_id:this.goodsData.old_recovery_category_id,
        }
        addStock(params).then(res=>{
            this.$message.success(res.message)
            this.visibleAddGood = false
            this.getList(1)
        }).catch(err=>{
          this.$message.error(err.message)
        })
      },
      /**
       * 获取商品分类
       * */
      getSelectFn(){
        categoryList({level:2}).then(res=>{
          res.data.list.unshift({
            cate_name:'全部',
            recovery_category_id:''
          })
          this.selectList = res.data.list
        }).catch(res=>{
          this.$message.error(res.message)
        })
      },
      addGoodsClose(){
        this.addGoodsShow = false
      },
      abnormalChange(e,index){
        let indx = null
        this.abnormalForm.worn_list.some((v,i)=>{
          console.log(v.txt,e)
          if(v.txt == e){
            indx = i
            return true
          }
        })
        console.log(indx)
        if(indx){
          this.abnormalForm.worn_list[index].txt = ''
        }
      },
      // 导出今日库存
      async stockCardDateFn(row){
        let excelData = JSON.parse(JSON.stringify(this.tableFrom))
        let data = []
        excelData.page = 1
        let pageCount = 1
        let lebData = {};
        console.log(pageCount)
        for (let i = 0; i < pageCount; i++) {
          console.log(i)
          lebData = await stockCardDate(excelData)
          console.log(lebData.data)
          pageCount = Math.ceil(lebData.data.count/excelData.limit)
          if (lebData.data.export.length) {
            data = data.concat(lebData.data.export)
            excelData.page++
          }
        }
        console.log(data,lebData,'-----------========')
        createWorkBook(lebData.data.header, lebData.data.title, data, lebData.data.foot,lebData.data.filename);
      },
      getTimeFn(){
        let date = new Date()
        let y = date.getFullYear()
        let m = date.getMonth()+1
        let d = date.getDate()
        console.log(y,m,d)
        this.tableFrom.date = y+'-'+(m<10?'0'+m:m)+'-'+(d<10?'0'+d:d)
      },
      checkChangeFn(e){
        // 判断是选中
        console.log(e)
        if(e.length - this.checkLst.length > 0){
          e.map((v,i)=>{
            let indx = 'null'
            this.checkLst.some((item,index)=>{
              if(v.recovery_attr_id == item.recovery_attr_id){
                indx = index
                return true
              }
            })
            if(indx == 'null'){
              v.recoveryNum = 1
              v.batch_list = []
              this.checkLst.push(v)
            }
          })
        }else{ // 取消选中
          this.checkLst.map((v,i)=>{
            let indx = 'null'
            e.some((item,index)=>{
              if(v.recovery_attr_id == item.recovery_attr_id){
                indx = index
                return true
              }
            })
            if(indx == 'null'){
              this.checkLst.splice(i,1)
            }
          })
        }

        // this.checkLst = JSON.parse(JSON.stringify(e))

      },
      stockOutConfirm(){
        let params = {
          stock:this.gooditem.stock,
          attr_id:this.gooditem.recovery_attr_id,
          recovery_category_id:this.gooditem.recovery_category_id
        }
        stockAdd(params).then(res=>{
          this.$message.success(res.message)
          this.addGoodsShow=false
          this.getList(1)
        }).catch(err=>{
          this.$message.error(err.message)
        })
      },
      // 时间搜索
      getSearchListFn(){
        this.getList()
        this.getCardList()
      },
      /**
       * 提交添加异常
       * */
      abnormalConfirm(){
        stockSetWorn(this.stockId,this.abnormalForm).then(res=>{
          this.abnormalVisible = false
          this.getList()
        }).catch(err=>{
          this.$message.error(err.message)
        })
      },
      /**
       * 搜索
       * */
      getSearchFn(){
        if(!this.keywords){
          this.$message.error('请输入搜索内容')
          return
        }
        recoveryStockListApi({page:1,limit:'max',keywords:this.keywords,num:0,}).then(res => {
          this.itemList = res.data.list
          // this.getCardList()
        }).catch(res => {
          this.$message.error(res.message)
        })
      },
      /**
       * 修改客戶
       * */
      editFn(row){
        this.addClientShow = true
        this.addType = 'edit'
        this.formData = JSON.parse(JSON.stringify(row))
      },
      deleteConfirmFn(){
        customDelete(this.deleteData.custom_id).then(res=>{
          this.getList()
          this.deleteShow = false
        }).catch(err=>{
          this.$message.error(err.message)
        })
      },
      detailChange(page){
        this.detailFrom.page = page
        this.getDetailListFn('')
      },
      detailSizeChange(val){
        this.detailFrom.limit = val
        this.getDetailListFn()
      },
      addGoodsFn(){
        this.itemList=[]
        this.keywords =''
        this.gooditem={}
        this.addGoodsShow = true
      },
      getGoodsFn() {//获取商品分类
        recoveryCategorySkuListApi().then((res) => {
          let tree = res.data.map((res => {
            res.disabled = true
            res.children.map((res2) => {
              res2.disabled = true
              res2.children.map((res3 => {
                res3.disabled = true
                res3.children.map((res4 => {
                  res4.old_recovery_category_id = res4.recovery_category_id
                  res4.recovery_category_id = res4.recovery_attr_id
                }))
              }))
            })
            return res
          }))
          this.treeData = tree
        })
      },
      /**
       * 获取库存明细
       * */
      stockDetailsLstFn(row){
        console.log(row)
        this.recovery_stock_id = row.recovery_attr_id
        this.stockDetailShow = true
        this.getDetailListFn()
      },
      getDetailListFn(){
        stockDetailsLst(this.recovery_stock_id,this.detailFrom).then(res=>{
          this.stockDetail = res.data.list
          this.detailFrom.total = res.data.count

        })
      },
      /**
       * 删除客户
       * */
      deleteFn(row){
        this.deleteData = row
        this.deleteShow = true
      },
      /**
       * 添加客户
       * */
      async addClientFn(){
        if(!this.formData.custom_name){
          this.$message.error('请输入客户名字')
          return
        }
        if(!this.formData.custom_contact){
          this.$message.error('请输入客户电话')
          return
        }
        let id = this.formData.custom_id?this.formData.custom_id:null
        let data = await customCreate(id,this.formData)
        console.log(data)
        this.getList()
        this.addClientShow = false
      },
      addKehuFn(){
        this.formData = {}
        this.addType = 'add'
        this.addClientShow = true
      },
      /**
       * 增加批号
       * */
      addBatchFn(){
        let num = 0
        this.ruleForm.batch_list.map((item,index)=>{
          num+= item.batch_num
        })
        if(num < this.ruleForm.stock){
          this.ruleForm.batch_list.push({batch_number:'',batch_num: 1})
        }

      },
      /**
       * 修改库存
       */
      async batchConfirm(){
        console.log(this.stockId,this.ruleForm)
        if(this.ruleForm.type == 2){
          dateQuicklyUpdate(this.stockId,this.ruleForm).then(res=>{
            this.$message.success(res.message)
            this.getList()
            this.ruleForm={
              outbound_price:'',
              type:1,
              stock:1,
              batch_list:[],
            }
            this.handleClose()
          }).catch(err=>{
            this.$message.error(err.message)
          })
        }else{ // 减少添加
          /**
           * 判断批号是否输入完整
           * */
          if(this.ruleForm.batch_list.some((v,i)=>{if(!v.batch_number)return true}))
          {
            this.$message.error('请检查批号是否输入完整')
            return
          }
          stockSetDateUpdate(this.stockId,this.ruleForm).then(res=>{
            this.$message.success(res.message)
            this.ruleForm={
              outbound_price:'',
              type:1,
              stock:1,
              batch_list:[],
            }
            this.getList()
            this.handleClose()
          }).catch(err=>{
            this.$message.error(err.message)
          })
        }

      },
      handleClose(){
        this.dialogVisible = false
      },
      batchChange(e,index){
        if(e<=0){
          this.$nextTick(()=>{
            this.ruleForm.batch_list.splice(index,1)
          })
        }
      },
      // 选择时间
      selectChange(tab) {
        this.tableFrom.date = tab;
        this.tableFrom.page = 1;
        this.timeVal = [];
        this.getList(1);
      },
      // 具体日期
      onchangeTime(e) {
        this.timeVal = e;
        this.tableFrom.date = e ? this.timeVal.join("-") : "";
        this.tableFrom.page = 1;
        this.getList(1);
      },
      // 列表
      getList(num) {
        this.listLoading = true
        this.tableFrom.page = num ? num : this.tableFrom.page
        console.log(this.tableFrom)
        stockDateList(this.tableFrom).then(res => {
          this.tableData.data = res.data.list
          this.tableData.total = res.data.count
          this.listLoading = false
          this.getCardList()
        }).catch(res => {
          this.listLoading = false
          this.$message.error(res.message)
        })
      },
      pageChange(page) {
        this.tableFrom.page = page
        this.getList('')
      },
      handleSizeChange(val) {
        this.tableFrom.limit = val
        this.getList('')
      },
      getCardList(){
        console.log(this.tableForm)
        tockCardDate(this.tableFrom)
          .then((res) => {
            this.cardLists = res.data;
          })
          .catch((res) => {
            this.$message.error(res.message);
          });
      },
      /**
       * @description 设置异常弹框
       * */
      setAbnormalStock(){
        this.abnormalVisible = true
        this.stockId = row.recovery_stock_id
        this.ruleForm={
          outbound_price:'',
          type:1,
          stock:1,
          batch_list:[],
        }
      },
      /**
       * @description 编辑每日库存弹框
       * */
      setRecoveryStock(row) {
        this.dialogVisible = true
        this.stockId = row.recovery_attr_id
        this.stockItem = row
        this.ruleForm={
          outbound_price:'',
          type:1,
          stock:1,
          batch_list:[],
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  .box-container {
    overflow: hidden;
  }
  .box-container .list {
    float: left;
    line-height: 40px;
  }
  .box-container .sp {
    width: 50%;
  }
  .box-container .sp3 {
    width: 33.3333%;
  }
  .box-container .sp100 {
    width: 100%;
  }
  .box-container .list .name {
    display: inline-block;
    width: 150px;
    text-align: right;
    color: #606266;
  }
  .box-container .list.image {
    margin-bottom: 40px;
  }
  .box-container .list.image img {
    position: relative;
    top: 40px;
  }
  /deep/.el-checkbox{
    display: flex;
    align-items: center;
  }
  /deep/.el-form-item__content .el-rate{
    position: relative;
    top: 8px;
  }
  /deep/ .el-radio-group{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
</style>
